import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Location } from '../components/Location';
import { CheckCircle2Icon } from 'lucide-react';
const inputClasses = 'w-full py-3 input-minimal text-[15px]';
const labelClasses = 'block text-[10px] font-medium text-navy/40 mb-1 tracking-[0.2em] uppercase';
export function ContactPage() {
  const {
    t
  } = useLanguage();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <motion.div initial={{
    opacity: 0,
    filter: 'blur(4px)'
  }} animate={{
    opacity: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    filter: 'blur(4px)'
  }} transition={{
    duration: 0.6,
    ease: [0.4, 0, 0.2, 1]
  }} data-id="element-384">
      <PageHeader title={t.location.title} subtitle={t.location.subtitle} backgroundImage="https://images.unsplash.com/photo-1498654896293-37aacf113fd9?w=1200" data-id="element-385" />

      <Location data-id="element-386" />

      {/* Contact Form */}
      <section className="py-32 lg:py-44 relative overflow-hidden" data-id="element-387">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full z-0" data-id="element-388">
          <video autoPlay loop muted playsInline className="object-cover w-full h-full opacity-40 scale-105" data-id="element-389">
            <source src="https://videos.pexels.com/video-files/1448735/1448735-uhd_2560_1440_24fps.mp4" type="video/mp4" data-id="element-390" />
          </video>
          <div className="absolute inset-0 bg-warmWhite/85 backdrop-blur-[4px]" data-id="element-391" />
          <div className="absolute inset-0 warm-glow opacity-50" data-id="element-392" />
        </div>

        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-10 relative z-10" data-id="element-393">
          <div className="text-center mb-16" data-id="element-394">
            <motion.div initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex items-center justify-center gap-5 mb-6" data-id="element-395">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-sand/50" data-id="element-396"></div>
              <span className="text-sand text-[11px] font-medium tracking-[0.35em] uppercase" data-id="element-397">
                {t.location.contactFormSubtitle}
              </span>
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-sand/50" data-id="element-398"></div>
            </motion.div>
            <motion.h2 initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1,
            duration: 0.8
          }} className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] text-navy" data-id="element-399">
              {t.location.contactFormTitle}
            </motion.h2>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 25
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.4, 0, 0.2, 1]
        }} className="glass-card p-10 md:p-16 rounded-xs" data-id="element-400">
            {isSubmitted ? <div className="text-center py-16" data-id="element-401">
                <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              type: 'spring',
              stiffness: 200,
              damping: 20
            }} data-id="element-402">
                  <CheckCircle2Icon className="w-16 h-16 text-sand mx-auto mb-8" data-id="element-403" />
                </motion.div>
                <p className="text-navy font-serif text-2xl" data-id="element-404">
                  {t.location.formSuccess}
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-10" data-id="element-405">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8" data-id="element-406">
                  <div data-id="element-407">
                    <label htmlFor="contactName" className={labelClasses} data-id="element-408">
                      {t.location.formName}
                    </label>
                    <input type="text" id="contactName" required className={inputClasses} data-id="element-409" />
                  </div>
                  <div data-id="element-410">
                    <label htmlFor="contactEmail" className={labelClasses} data-id="element-411">
                      {t.location.formEmail}
                    </label>
                    <input type="email" id="contactEmail" required className={inputClasses} data-id="element-412" />
                  </div>
                </div>
                <div data-id="element-413">
                  <label htmlFor="contactMessage" className={labelClasses} data-id="element-414">
                    {t.location.formMessage}
                  </label>
                  <textarea id="contactMessage" required rows={3} className={inputClasses + ' resize-none'} data-id="element-415"></textarea>
                </div>
                <div className="pt-4" data-id="element-416">
                  <button type="submit" className="w-full bg-navy/95 backdrop-blur-sm hover:bg-navy text-white font-medium py-4.5 transition-all duration-700 ease-elegant tracking-[0.2em] uppercase text-[11px] hover:shadow-elegant hover:scale-[1.01]" data-id="element-417">
                    {t.location.formSubmit}
                  </button>
                </div>
              </form>}
          </motion.div>
        </div>
      </section>
    </motion.div>;
}